<template>
  <div class="dialog-body">
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body width="60%" center>
      <div class="formClass">
        <formItem
          ref="dialogFormRef"
          :params="dialogData"
          :columns="baseColumns"
          :rules="baseRules"
          labelWidth="120px"
        >
        </formItem>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSure">提交审核</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { auditDialogFormCells } from './columns';
  import DepositCommonMixin from '../../mixins/DepositCommonMixin';
  import formItem from '@/pages/intermodality/common/components/form-item.vue';

  export default {
    name: 'DepositActionDialog',
    mixins: [DepositCommonMixin],
    components: {
      formItem,
    },
    data() {
      return {
        dialogVisible: false,
        //0退回1罚没
        dialogType: 0,
        dialogData: {
          id: null,
          depositNo: null,
          contractNo: null,
          contractName: null,
          contractType: null,
          customerName: null,
          customerNo: null,
          depositAmount: null,
          depositBalance: null,
          applicationAmount: null,
          applicationType: null,
          signPartyName: null,
          reason: null,
        },
        validatorAmount: (ctx) => {
          return (_, value, callback) => {
            if (value) {
              let balance = Number(ctx.dialogData.depositBalance ?? 0);
              let amount = Number(value);
              if (balance - amount < 0) {
                callback(new Error('申请额度不能大于押金余额'));
              }
              return callback();
            } else {
              return callback();
            }
          };
        },
      };
    },
    computed: {
      baseColumns() {
        return auditDialogFormCells(this);
      },
      baseRules() {
        return {
          applicationAmount: [
            {
              required: true,
              message: '必填字段',
            },
            { validator: this.validatorAmount(this), trigger: ['blur', 'change'] },
          ],
          reason: [
            {
              required: true,
              message: '必填字段',
            },
          ],
        };
      },
      title() {
        if (this.dialogType == 0) {
          return '押金退回';
        } else {
          return '押金罚没';
        }
      },
    },
    methods: {
      async openDialog(type, data) {
        console.log('applyDepositAction', type, data);
        this.dialogVisible = true;
        this.dialogType = type;
        for (let key in this.dialogData) {
          this.dialogData[key] = data[key];
        }
      },
      handleClose() {
        this.dialogVisible = false;
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
      },
      handleSure() {
        this.$refs['dialogFormRef'].validate(async (valid) => {
          if (valid) {
            let data = { ...this.dialogData };
            data.depositId = this.dialogData.id;

            if (this.dialogType == 0) {
              // "申请类型 (01-退回,02-罚没)")
              data.applicationType = '01';
            } else {
              data.applicationType = '02';
            }
            this.loading.startLoading();
            let res = await this.depositAction(this.dialogType, data);
            this.loading.endLoading();
            if (res == 'success') {
              this.handleClose();
              this.$emit('handleSure', data);
            }
          }
        });
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .formClass {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog-footer {
    text-align: center;
  }
</style>
